import { render, staticRenderFns } from "./ModalPublishEvent.vue?vue&type=template&id=f255db78&"
import script from "./ModalPublishEvent.vue?vue&type=script&lang=js&"
export * from "./ModalPublishEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports